import { ValueOf } from '@@types/common';

export enum MemberStatusField {
  MEMBER = 'member',
  WAITING = 'waiting',
  DORMANT = 'dormant',
  AUTO_DORMANT = 'autoDormant',
  LEAVED = 'leaved',
  DESTRUCTED = 'destructed',
}

export enum MemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
  SUB_MEMBER = 'subMember',
  GUEST = 'guest',
  LEAVER = 'leaver',
}

export type TenantMemberRole =
  | MemberRole.OWNER
  | MemberRole.ADMIN
  | MemberRole.MEMBER
  | MemberRole.SUB_MEMBER
  | MemberRole.GUEST
  | MemberRole.LEAVER
  | 'channel'; // channel mention 만 custom 으로 처리
export type OrgMemberRole = MemberRole.OWNER | MemberRole.ADMIN | MemberRole.MEMBER;

export enum IdProviderId {
  NHN_SSO = '4',
  IAM = '5',
}

export const PreferenceCategory = {
  COACH_MARK: 'coachMark',
  LANG: 'lang',
  NEW_LINE_MANNER: 'newLineManner',
  NOTIFICATION: 'notification',
  NOTIFICATION_RANGE: 'notificationRange',
  VOIP: 'voip',
  FORCE_PUSH: 'forcePush',
  THREAD: 'thread',
};
export type PreferenceCategory = ValueOf<typeof PreferenceCategory>;

export const OFFICE_HOURS_KEY = {
  CHANNEL: 'channel',
} as const;
export type OfficeHoursKey = ValueOf<typeof OFFICE_HOURS_KEY>;
